import { get, post } from '@/api/axios';
import { type ExportColumnDto } from '@/app/models/ExportColumnDto';
import { type ExportRequestDto } from '@/app/models/ExportRequestDto';
import { type ExportTaskDto } from '@/app/models/ExportTaskDto';

export const fetchExportColumns = (exportEndpoint: string) =>
  get<ExportColumnDto[]>(`${exportEndpoint}/columns`).then((response) => response.data);

/**
 * Pede a exportação e devolve o nome da tarefa. Não espera: a tarefa é do usuário e segue sendo acompanhada
 * pelo cache de tarefas (aba Tarefas do sino), mesmo com o modal fechado.
 */
export const startExport = (exportEndpoint: string, request: ExportRequestDto) =>
  post<ExportTaskDto>(exportEndpoint, request).then((response) => response.data.task_name);
